import type {
  GlobalContextAction,
  GlobalContextReducerState
} from './reducers/types';

export interface GlobalContextProviderProps {
  children: React.ReactNode;
  initialValue?: GlobalContextReducerState;
}

export enum ContextAction {
  setLayout = 'SET_LAYOUT',
  setLang = 'SET_LANG',
  setUser = 'SET_USER',
  resetUser = 'RESET_USER',
  setToast = 'SET_TOAST',
  setPermissions = 'SET_PERMISSIONS',
  resetPermissions = 'RESET_PERMISSIONS',
  setRouteConfig = 'SET_ROUTE_CONFIG',
  setVerifierAuthentication = 'SET_VERIFIER_AUTHENTICATION',
  resetVerifierAuthentication = 'RESET_VERIFIER_AUTHENTICATION',
  setClaimDetails = 'SET_CLAIM_DETAILS',
  setCoBrandDetails = 'SET_CO_BRAND_DETAILS',
  setActiveFeatureConfig = 'SET_ACTIVE_FEATURE_CONFIG'
}

export interface GlobalContextState {
  state: GlobalContextReducerState;
  dispatch: React.Dispatch<GlobalContextAction>;
}
